import { isCommentNode } from 'anodum';
import isTextNodeWithSpacingOnly from '../verifiers/is-text-node-with-spacing-only';

const findNextNode = (node, breakNode = null) => {
  let currentNode = node;

  while (currentNode) {
    if (currentNode === breakNode) {
      return null;
    }

    if (currentNode.nextSibling) {
      currentNode = currentNode.nextSibling;
      if (!isTextNodeWithSpacingOnly(currentNode) && !isCommentNode(currentNode)) {
        break;
      }
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return currentNode;
};

export default findNextNode;
